import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import {
  REACT_APP_AUTH0_CLIENT_ID,
  REACT_APP_AUTH0_DOMAIN,
} from "./common/constant";
import { history } from "./jwt/_helpers";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { decryptData, getSecret } from "./common/common";
import { SSMKeys } from "./common/common"

const domain = REACT_APP_AUTH0_DOMAIN;
const clientId = REACT_APP_AUTH0_CLIENT_ID;

const onRedirectCallback = (appState) => {
  history.push(appState?.returnTo || window.location.pathname);
};

document.addEventListener("DOMContentLoaded", async () => {
  const stripe_key = await getSecret(SSMKeys.stripePk).then((res) => decryptData(res));
  const stripePromise = loadStripe(stripe_key);
  ReactDOM.render(
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={window.location.origin}
      buildLogoutUrl={window.location.origin}
      onRedirectCallback={onRedirectCallback}
    >
      <Elements stripe={stripePromise}>
        <App />
      </Elements>
    </Auth0Provider>,
    document.getElementById("root")
  );
});
